// Import manifests as URLs so Parcel processes them
var $555d77182d977fd0$exports = {};
$555d77182d977fd0$exports = import.meta.resolve("8kO8H");


const $5efb2fcba4c8256f$var$manifestUrl = new URL($555d77182d977fd0$exports).toString();
var $119cf9898c547df1$exports = {};
$119cf9898c547df1$exports = import.meta.resolve("hGeiZ");


const $5efb2fcba4c8256f$var$desktopManifestUrl = new URL($119cf9898c547df1$exports).toString();
const $5efb2fcba4c8256f$var$injectManifest = ()=>{
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    const targetManifest = isMobile ? $5efb2fcba4c8256f$var$manifestUrl : $5efb2fcba4c8256f$var$desktopManifestUrl;
    const link = document.createElement('link');
    link.rel = 'manifest';
    link.href = targetManifest;
    document.head.appendChild(link);
};
$5efb2fcba4c8256f$var$injectManifest();


//# sourceMappingURL=app.faf2b5d0.js.map
